'use client';
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import EmailGate from './EmailGate';

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(true);
  return (
    <EmailGate>
      <div className="flex h-screen overflow-hidden" style={{ background: '#f8fafc' }}>
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
        <main
          className={`flex-1 overflow-y-auto transition-all duration-300 ${collapsed ? 'ml-0' : 'ml-0'}`}
        >
          {children}
        </main>
        <div className="fixed bottom-3 right-3 text-xs select-none pointer-events-none z-50" style={{ color: '#cbd5e1' }}>
          v2.5
        </div>
      </div>
    </EmailGate>
  );
}